import deepClone from 'lodash.clonedeep'

import { TopContentFields } from '../../../../domain/models/content-fields'
import { NodeTypes, State } from '../../../types'
import { ActionType } from '../../action-types'
import { ReversibleAction } from '../reversible-action'
import { NodeAction } from './node-action'

export interface UpdateNodeInterface {
  type: ActionType.UpdateNode
  data: TopContentFields
}

export interface UpdateNodeHistoryChange {
  type: ActionType.UpdateNode
  newData: TopContentFields
  oldData: TopContentFields
  currentNode?: NodeTypes
  currentFlowId: string
}

export class UpdateNodeAction extends ReversibleAction {
  static apply = (state: State, newData: TopContentFields): void => {
    const node = NodeAction.getNodeById(state, newData.id)
    const oldData = deepClone(node?.data)
    if (node && oldData) {
      newData.setErrors()
      if (
        oldData.errors.fieldErrors.length === 0 &&
        !newData.errors.hasDuplicatedIdentifier
      ) {
        newData.errors.showErrors = false
      }
      this.trackHistoryChange(state, newData, oldData)
      node.data = newData
      state.currentNode = node
      this.checkDuplicatedIdentifier(state, newData, oldData)
    }
  }

  static undo = (state: State, change: UpdateNodeHistoryChange) => {
    const node = NodeAction.getNodeById(state, change.oldData.id)
    if (node) {
      node.data = change.oldData
      this.checkDuplicatedIdentifier(state, change.oldData, change.newData)
    }
  }

  static redo = (state: State, change: UpdateNodeHistoryChange) => {
    const node = NodeAction.getNodeById(state, change.newData.id)
    if (node) {
      node.data = change.newData
      state.currentNode = node
      this.checkDuplicatedIdentifier(state, change.newData, change.oldData)
    }
  }

  private static trackHistoryChange = (
    state: State,
    newData: TopContentFields,
    oldData: TopContentFields
  ) => {
    const newChange: UpdateNodeHistoryChange = {
      type: ActionType.UpdateNode,
      newData,
      oldData,
      currentNode: state.currentNode,
      currentFlowId: state.currentFlowId,
    }
    this.updateChangesHistory(state, newChange)
  }

  private static checkDuplicatedIdentifier = (
    state: State,
    newData: TopContentFields,
    oldData: TopContentFields
  ) => {
    if (newData.getIdentifier() === oldData.getIdentifier()) return
    NodeAction.reportDuplicatedIdentifier(state)
  }
}
